<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{inventoryOutputPrintModel.inventoryOutputId}}" class="head col-12 col-lg-12">
                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryOutputPrintModel.branchName}}</p>

                  <!--Nombre Salida Inv. -->
                  <p id="nombre-salida-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'SALIDA INVENTARIO Nro.'+ inventoryOutputPrintModel.consecutive}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{inventoryOutputPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{inventoryOutputPrintModel.address}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-telefono' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{inventoryOutputPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{inventoryOutputPrintModel.phone}}</p>

                  <!-- Fecha salida -->
                  <label id="t-fecha-salida-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-fecha-salida-inventario' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-salida-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{inventoryOutputPrintModel.dateOutput | date: 'dd/MM/yyyy'}}</p>

                  <!-- Nit Cliente  -->
                  <label id="t-nit-cliente-{{inventoryOutputPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-nit-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-cliente-{{inventoryOutputPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{inventoryOutputPrintModel.clientNit }}
                  </p>

                  <!-- Cliente  -->
                  <label id="t-cliente-{{inventoryOutputPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{inventoryOutputPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{inventoryOutputPrintModel.clientName }}</p>

                  <!-- Inventario  -->
                  <label id="t-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}" for=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-inventario' | formatLabelPipe : elementsLabel}}</label>
                  <p id="inventario-{{inventoryOutputPrintModel.inventoryOutputId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{inventoryOutputPrintModel.inventoryName}}
                  </p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-salida-inventario-{{ inventoryOutputPrintModel.inventoryOutputId }}"
                  [columns]="columns" [data]="inventoryOutputPrintModel.inventoryOutputDetails" [idMap]="idMap"
                  [documentId]="inventoryOutputPrintModel.inventoryOutputId" [footerVisible]="true"
                  [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Observaciones -->
          <div id="foot-{{inventoryOutputPrintModel.inventoryOutputId}}" class="foot mt-1 container-observations">
            <label id="t-observacion-salida-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
              *ngIf="inventoryOutputPrintModel.observation">
              {{'t-observacion-salida-inventario' | formatLabelPipe : elementsLabel}}</label>
            <p id="observacion-salida-inventario-{{inventoryOutputPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
              *ngIf="inventoryOutputPrintModel.observation">
              {{inventoryOutputPrintModel.observation}}</p>

            <!-- Firma Recibido-->
            <p id="linea-firma-recibido-{{inventoryOutputPrintModel.inventoryOutputId}}" class="write-line"
              (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-recibido-{{inventoryOutputPrintModel.inventoryOutputId}}"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
              {{'t-linea-recibido' | formatLabelPipe : elementsLabel}}</label>
          </div>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{inventoryOutputPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>